/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import BannerCta from "./BannerCta";

const BannerCtaContainer = ({
  bannerData,
  toggleModal,
  setToggleModal
}) => {
  return (
    <BannerCta
      bannerData={bannerData}
      setToggleModal={setToggleModal}
      toggleModal={toggleModal}
    />
  );
};

export default BannerCtaContainer;
